import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { ApiService } from './api.service';

export interface SearchResult {
  type: string;
  id: number;
  title: string;
  subtitle?: string;
  status?: string;
  date?: string;
}

export interface SearchResponse {
  products?: any[];
  customers?: any[];
  vendors?: any[];
  salesOrders?: any[];
  purchaseOrders?: any[];
  salesInvoices?: any[];
  proformas?: any[];
}

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private querySubject = new BehaviorSubject<string>('');
  query$ = this.querySubject.asObservable();

  constructor(private apiService: ApiService) {}

  setQuery(query: string): void {
    this.querySubject.next(query);
  }

  search(query: string): Observable<SearchResponse> {
    const params = new HttpParams().set('q', query);
    return this.apiService.get<SearchResponse>('search/all', params);
  }
}
